import { createRichMediaTransformers } from '@change-corgi/core-react/richMediaTags';

import { useMediaAssetsBasePath } from 'src/app/shared/hooks/assets';

import { removeRichMediaWrapper } from '../utils/removeRichMediaWrapper';

type UseTransformChangeTags = {
	transformFromChangeTags: (html: string) => string;
	transformToChangeTags: (html: string) => string;
};

export function useTransformChangeTags(): UseTransformChangeTags {
	const assetBasePath = useMediaAssetsBasePath({ mode: 'edit' });
	const { decodeRichMediaTransformer, encodeRichMediaTransformer } = createRichMediaTransformers({ assetBasePath });

	const transformFromChangeTags = (html: string): string => decodeRichMediaTransformer.transformHtml(html);
	const transformToChangeTags = (html: string): string =>
		removeRichMediaWrapper(encodeRichMediaTransformer.transformHtml(html));

	return { transformFromChangeTags, transformToChangeTags };
}
